import { create } from "zustand";

const useProfileDataStore = create((set) => ({
  userProfile: null,
  setUserProfile: (data) => set({ userProfile: data }),
}));

export default useProfileDataStore;
